import { configureStore } from '@reduxjs/toolkit';
import adminReducer from '../admin/store/slices/adminSlice';
import dashboardReducer from '../admin/store/slices/dashboardSlice';
import booksReducer from '../admin/store/slices/booksSlice';
import ordersReducer from '../admin/store/slices/ordersSlice';
import usersReducer from '../admin/store/slices/usersSlice';
import transactionsReducer from '../admin/store/slices/transactionsSlice';
import parcelsReducer from '../admin/store/slices/parcelsSlice';

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    dashboard: dashboardReducer,
    books: booksReducer,
    adminOrders: ordersReducer,
    adminUsers: usersReducer,
    adminTransactions: transactionsReducer,
    adminParcels: parcelsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
}); 